import {
  getModule,
  Module,
  VuexModule,
  MutationAction
} from "vuex-module-decorators";
import store from "@/store";
import { SessionStorage } from "@/store/session-storage";
import {
  SearchResponse,
  SearchItem
} from "@/api/app-creation-status-shop/response";
import { SearchRequest } from "@/api/app-creation-status-shop/request";
import * as AppCreationStatusShopAPI from "@/api/app-creation-status-shop";
import { isSuccess } from "@/api/response";

const MODULE_NAME = "app-creation-status-shop/search";

/**
 * 店舗のデコレーター
 */
export class ListItem {
  constructor(private _item: SearchItem) {}
  get id() {
    return this._item.id;
  }
  get name() {
    return this._item.name;
  }
  get appName() {
    return this._item.appName;
  }
  get shopTypeName() {
    return this._item.shopTypeName;
  }
  get viewFlg() {
    return this._item.viewFlgName;
  }
  get androidFlg() {
    return this._item.androidFlgName;
  }
  get appStatusAndroid() {
    return this._item.appStatusAndroidName;
  }
  get iosFlg() {
    return this._item.iosFlgName;
  }
  get appStatusIos() {
    return this._item.appStatusIosName;
  }
  get writeFlg() {
    return 1;
  }
}

/**
 * アプリ作成状況一覧・検索API（/search-app-creation-status-shop）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Search extends VuexModule {
  // state
  searchRequest: SearchRequest = {} as SearchRequest;
  searchResponse: SearchResponse = {} as SearchResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.searchResponse);
  }

  get getMessage() {
    return this.searchResponse.message;
  }

  get getItems() {
    if (this.searchResponse.results) {
      return (this.searchResponse.results.items || []).map(
        value => new ListItem(value)
      );
    } else {
      return [];
    }
  }

  get getTotalCount() {
    if (this.searchResponse.results) {
      return this.searchResponse.results.totalCount || 0;
    } else {
      return 0;
    }
  }

  get getSearchRequest() {
    return this.searchRequest;
  }

  // MutationActions
  @MutationAction
  async search(searchRequest: SearchRequest) {
    const searchResponse = await AppCreationStatusShopAPI.search(searchRequest);
    SessionStorage.setObject(MODULE_NAME, searchRequest);
    return {
      searchRequest,
      searchResponse
    };
  }

  @MutationAction
  async restore(initial = {} as SearchRequest) {
    const searchRequest = SessionStorage.getObject(
      MODULE_NAME,
      initial
    ) as SearchRequest;
    return {
      searchRequest
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      searchResponse: {} as SearchResponse
    };
  }
}

export default getModule(Search);
